import { render, staticRenderFns } from "./DeniedDetails.vue?vue&type=template&id=4286fb9f"
import script from "./DeniedDetails.vue?vue&type=script&lang=js"
export * from "./DeniedDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports